// extracted by mini-css-extract-plugin
export default {"coin_page_container":"CoinPage_coin_page_container__CN93i"};